import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/midders/Code/xedi-microservices/sdk-js/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Flash } from '@primer/components';
import { InfoIcon } from '@primer/styled-octicons';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`XEDI.js includes Axios in its bundle. It is contained so should not interfere with other instances of Axios you may be running.`}</p>
    <p>{`Axios allows XEDI.js to be used in browsers and (in theory) in Node.js applications.`}</p>
    <Flash scheme="yellow" mb={2} mdxType="Flash">
    <InfoIcon mr={1} mdxType="InfoIcon" /> Node.js applications aren't currently supported.
    </Flash>
    <p>{`Just like the API classes, XEDI.js uses an instance of Axios.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      